function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { TextField } from "@bolteu/kalep-react";
export var NumberField = function NumberFieldComponent(_a) {
  var _b, _c, _d;
  var onChange = _a.onChange,
    value = _a.value,
    validatorResults = _a.validatorResults,
    _a$unitPosition = _a.unitPosition,
    unitPosition = _a$unitPosition === void 0 ? "end" : _a$unitPosition,
    _a$showArrows = _a.showArrows,
    showArrows = _a$showArrows === void 0 ? true : _a$showArrows,
    label = _a.label,
    name = _a.name,
    unit = _a.unit,
    helperText = _a.helperText,
    isCompact = _a.compact,
    rest = __rest(_a, ["onChange", "value", "validatorResults", "unitPosition", "showArrows", "label", "name", "unit", "helperText", "compact"]);
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalValue = _React$useState2[0],
    setInternalValue = _React$useState2[1];
  // This useEffect is needed in case you want
  // to map form state into internal state of CustomComponent
  // props.value can be undefined in case Form form data is still not present
  React.useEffect(function () {
    if (value !== undefined && Number(internalValue) !== value) {
      setInternalValue(value);
    }
  }, [value, internalValue]);
  var handleChange = React.useCallback(function (change) {
    var parsedValue = change.target.value.trim().length === 0 ? NaN : Number(change.target.value);
    var newValue = Number.isNaN(parsedValue) ? undefined : parsedValue;
    if (newValue !== undefined || change.target.value.trim().length === 0 || change.target.value === ".") {
      setInternalValue(change.target.value);
      onChange({
        value: newValue
      });
    }
    onChange({
      value: newValue
    });
  }, [onChange]);
  return /*#__PURE__*/React.createElement(TextField, Object.assign({
    autoComplete: "off",
    type: showArrows ? "number" : "tel",
    autoCapitalize: "off",
    name: name,
    error: !!validationError,
    helperText: (_c = (_b = validationError === null || validationError === void 0 ? void 0 : validationError.error) !== null && _b !== void 0 ? _b : helperText) !== null && _c !== void 0 ? _c : "",
    fullWidth: true,
    label: label !== null && label !== void 0 ? label : name,
    value: (_d = String(internalValue)) !== null && _d !== void 0 ? _d : "",
    onChange: handleChange,
    prefix: unit && unitPosition === "start" ? unit : undefined,
    suffix: unit && unitPosition === "end" ? unit : undefined,
    size: isCompact ? "sm" : undefined
  }, rest));
};